import React, { useCallback, useRef, useEffect } from "react";
import { Transition } from 'react-transition-group';

export const DropdownMenuMobile = ({ item, index, handleDropdownClick, closeDropdown, open, menuHeight }) => {
  const trigger = useRef(null);
  const content = useRef(null);
  const transitionRef = useRef(null);

  const defaultStyle = {
    transition: `transform 300ms ease-in-out`
  }

  const transitionStyles = {
    entering: { transform: 'translate(0)', visibility: 'visible' },
    entered:  {  transform: 'translate(0)', visibility: 'visible' },
    exiting:  { transform: 'translate(100%)', visibility: 'visible' },
    exited:  { transform: 'translate(100%)', visibility: 'hidden' },
  };

  const handleCloseDropdown = useCallback(() => {
    closeDropdown();
    trigger.current.focus();
  }, []);

  // If we are tabbing inside or outside of the dropdown, close it
  useEffect(() => {
    if (content) {
      content.current.addEventListener('keydown', (e) => {
        if (e.key === 'Tab') {
          const elements = content.current.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe");
          const first = elements[0];
          const last = elements[elements.length - 1];

          if (e.target === last && !e.shiftKey) closeDropdown();
          if (e.target === first && e.shiftKey) closeDropdown();
        }
      })
    }
  }, [content, trigger]);

  // When dropdown opens, focus on the first element
  useEffect(() => {
    if (open) {
      setTimeout(() => {
        const elements = content.current.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe");
        const first = elements[0];
        first.focus();
      }, 100);
    }
  }, [open]);

  return (
    <>
      <button 
        className="w-full flex items-center justify-between px-4 py-2 cursor-pointer"
        aria-controls={`DropdownContent-${index}`}
        data-dropdown-trigger={`DropdownTrigger-${index}`}
        onClick={() => handleDropdownClick(index)}
        aria-expanded={open}
        ref={trigger}
      >
        <span className="font-medium underline underline-offset-4 decoration-transparent hover:decoration-black transition uppercase">{item.title}</span>
        <svg aria-hidden="true" aria-focusable="false" width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.17192 6.99999L0.221924 2.04999L1.63592 0.635986L7.99992 6.99999L1.63592 13.364L0.221924 11.95L5.17192 6.99999Z" fill="black"/>
        </svg>
      </button>
      <Transition transitionRef={transitionRef} in={open} timeout={500}>
        {state => (
          <div 
            ref={transitionRef} 
            style={{
              ...defaultStyle,
              ...transitionStyles[state],
              height: `calc(100dvh - ${menuHeight}rem)`
            }}
            className={`transition absolute left-0 top-0 bg-blush-100 z-10 w-full w-full h-screen min-h-[50vh]`}
            id={`DropdownContent-${index}`}
          >
            <div ref={content}>
              <button
                className="px-4 py-[0.875rem] flex gap-[0.625rem] items-center text-gray-800 border-b border-taupe-200 w-full"
                onClick={handleCloseDropdown}
              >
                <svg aria-hidden="true" aria-focusable="false" width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2.82808 7.00001L7.77808 11.95L6.36408 13.364L7.62939e-05 7.00001L6.36408 0.636013L7.77808 2.05001L2.82808 7.00001Z" fill="currentColor"/>
                </svg>
                <span className="text-[0.8125rem] font-medium uppercase">Back</span>
              </button>
              <ul className="py-6" role="list">
                {item.links.map((childlink, i, items) => {
                  const isLast = i + 1 === items.length;
                  return (
                    <li className="list-none text-large">
                      <a 
                        href={childlink.url} 
                        className="px-4 py-2 inline-block text-sm uppercase"
                        aria-current={childlink.current}
                      >
                        {childlink.title}
                      </a>
                    </li>
                  )
                })}
              </ul>
            </div>
          </div>
        )}
      </Transition>
    </>
  )
}